import { DEFAULT_SPORT, isHockeyVariant, Sport } from './sport';

/**
 * The overlay image events are positioned on. Every pitch shares the ice
 * rink's 30x60 coordinate frame: Data Cockpit draws each sport's pitch scaled
 * into that frame, so positions stay comparable across systems and an older
 * Data Cockpit or aggregation still reads them right.
 */
export interface Pitch {
  id: PitchId;
  image: string;
  cornerRadiusPx: number;
}

// Stored with every event whose position is clicked (positionPitch), so
// positions clicked on different pictures can always be told apart later.
// Events without it were clicked before pictures were recorded, on the
// picture legacyPitchForSport() names.
export type PitchId = 'ICE_RINK' | 'FLOORBALL_IFF_2026' | 'INDOOR_HOCKEY';

export const ICE_RINK: Pitch = {
  id: 'ICE_RINK',
  image: '/assets/sihf_ice_rink.svg',
  cornerRadiusPx: 75
};

// 40 x 20 m with the markings of the IFF Rules of the Game 2026.
export const FLOORBALL_PITCH: Pitch = {
  id: 'FLOORBALL_IFF_2026',
  image: '/assets/floorball_pitch.svg',
  cornerRadiusPx: 20
};

export const INDOOR_HOCKEY_PITCH: Pitch = {
  id: 'INDOOR_HOCKEY',
  image: '/assets/indoor_hockey_pitch.svg',
  cornerRadiusPx: 0
};

// Field hockey has no overlay of its own yet and shares the indoor one.
export function pitchForSport(sport: Sport): Pitch {
  const resolvedSport = sport ?? DEFAULT_SPORT;
  if (resolvedSport === 'FLOORBALL') {
    return FLOORBALL_PITCH;
  }
  if (isHockeyVariant(resolvedSport)) {
    return INDOOR_HOCKEY_PITCH;
  }
  return ICE_RINK;
}

// The picture events without positionPitch were clicked on: floorball used the
// ice rink until it got its own picture, indoor and field hockey already had
// the indoor one.
export function legacyPitchForSport(sport: Sport): Pitch {
  return isHockeyVariant(sport ?? DEFAULT_SPORT)
    ? INDOOR_HOCKEY_PITCH
    : ICE_RINK;
}
